export const imageBreakpoints: Record<number, number | number[]> = {
	1920: 400,
	1680: 400,
	1600: 350,
	1536: 350,
	1440: 350,
	1366: 300,
	1280: 300,
	428: [400, 500, 600],
	414: [400, 500, 600],
	412: [400, 500, 600],
	393: [350, 400, 500],
	390: [350, 400, 500],
	385: [350, 400, 500],
	384: [350, 400, 500],
	375: [350, 400, 500],
	360: [350, 400, 500],
	320: [300, 350, 400],
};
